import React, { forwardRef } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { cn } from '../utils/cn';

const ControlledInput = forwardRef(
  ({ mask, name = '', label, rules, defaultValue = '', className = '', classContainer = '', children, ...inputProps }, ref) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();

    const error = get(errors, name);

    return (
      <Controller
        control={control}
        name={name}
        rules={rules && rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <div className={`relative mb-4 ${classContainer}`}>
            {label && (
              <label htmlFor={name} className="block text-gray-700 text-sm ml-2 mb-2">
                {label}
              </label>
            )}

            <div className="flex flex-row h-10 relative">
              {mask ? (
                <InputMask
                  mask={mask}
                  placeholder={inputProps?.placeholder ?? ''}
                  alwaysShowMask={false}
                  maskChar={' '}
                  onChange={field.onChange}
                  value={field.value}>
                  {(props) => (
                    <input
                      ref={ref}
                      className={cn(
                        `appearance-none border border-gray-300 pl-4 rounded-full w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none`,
                        'focus:border-black',
                        className
                      )}
                      {...props}
                    />
                  )}
                </InputMask>
              ) : (
                <input
                  ref={ref}
                  className={cn(
                    `appearance-none border border-gray-300 pl-4 rounded-full w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none`,
                    'focus:border-black',
                    className
                  )}
                  {...field}
                  {...inputProps}
                />
              )}
              {error && <span className={'absolute bottom-[-16px] text-xs text-red-500'}>{error?.message}</span>}
              {children}
            </div>
          </div>
        )}
      />
    );
  }
);

export default ControlledInput;
